<template>
  <modal
    name="privacyPolicy"
    modal-style="compact"
    :display-header-title="false"
  >
    <privacy-policy />
  </modal>
</template>


<script>
  import PrivacyPolicy from './privacy-policy/index.vue';


  export default {
    name: 'PrivacyPolicyModal',

    components: {
      PrivacyPolicy
    }
  };
</script>
